__turbopack_context__.v({
  "blok-big-title": "Callout-module__bvLAFq__blok-big-title",
  "blok-subtitle": "Callout-module__bvLAFq__blok-subtitle",
  "blok-title": "Callout-module__bvLAFq__blok-title",
  "callout": "Callout-module__bvLAFq__callout",
  "error": "Callout-module__bvLAFq__error",
  "icon": "Callout-module__bvLAFq__icon",
  "info": "Callout-module__bvLAFq__info",
  "message": "Callout-module__bvLAFq__message",
});
